import { AxiosInstance } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as requestUrl from "../../constants/request";
import { PayByTextApiResponse, PayByTextData } from "./paybytext-state";
import { deletePayByText } from "./paybytext-slice";
import { ThunkAPIConfig } from "store";

export type FetchPayByText = typeof fetchPayByText;

export const fetchPayByText = createAsyncThunk<
  PayByTextApiResponse[],
  {
    request: AxiosInstance;
  },
  ThunkAPIConfig
>("paybytext/fetch", async ({ request }, thunkAPI) => {
  const result = await request(
    `${requestUrl.FT_PAY_BY_TEXT}/enrollments/user-enrollments`
  );

  return result.data;
});

export type SavePayByText = typeof savePayByText;

export const savePayByText = createAsyncThunk<
  PayByTextData | null,
  {
    request: AxiosInstance;
    data: PayByTextData;
  },
  ThunkAPIConfig
>("paybytext/save", async ({ request, data }, thunkAPI) => {
  try {
    let response;
    if (data.status === 1 || data.status === 2) {
      response = await request(`${requestUrl.FT_PAY_BY_TEXT}/enrollments`, {
        method: "POST",
        data,
      });
    } else if (data.status === 0) {
      response = await request(`${requestUrl.FT_PAY_BY_TEXT}/enrollments`, {
        method: "DELETE",
        data,
      });

      thunkAPI.dispatch(deletePayByText(data.accountInformationId));
      return null;
    }
    if (!response || response.status < 200 || response.status >= 300) {
      return thunkAPI.rejectWithValue(response);
    }
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});
